import { putResolve } from 'redux-saga/effects';
import actions from '../../actions';
import * as AddVideoNoteMethods from '../../utils/api/field/AddVideoNoteData';

function* AddVideoNoteData(action) {
  const { payload, refreshPayload } = action;
  const promise = AddVideoNoteMethods.AddVideoNoteData(payload);
  const { res } = yield promise;
  yield putResolve({ type: actions.AddVideoNoteAction.ADDVIDEONOTE_RECEIVED, data: res.Response });

  if (refreshPayload) {
    yield putResolve({
      type: actions.analysisAction.REQUEST_ANALYSIS_CLIPS_WITHOUT_URL,
      payload: refreshPayload
    });
  }
}

export { AddVideoNoteData };
